// extracted by mini-css-extract-plugin
export default {"additionalPalletsList":"AdditionalPalletsList_additionalPalletsList__loyGJ","listItem":"AdditionalPalletsList_listItem__rfMPW"};